import { gql } from 'react-apollo';

export default gql`
  mutation offerRequestInformation($offerId: ID!, $message: String) {
    offerRequestInformation(offerId: $offerId, message: $message)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/offerRequestInformation.js